import React from 'react';
import './AdminLoading.css';

/**
 * Admin panel loading component - golden theme
 * @param {string} title - Main loading title (e.g. "Loading Dashboard")
 * @param {string} subtitle - Optional subtitle (e.g. "Fetching analytics...")
 * @param {string} icon - Optional emoji or icon class for context (e.g. "📊", "📦")
 */
const AdminLoading = ({ title = 'Loading...', subtitle, icon }) => {
  return (
    <div className="admin-loading">
      <div className="admin-loading-content">
        <div className="admin-loading-spinner">
          <div className="admin-spinner-ring"></div>
          <div className="admin-spinner-ring"></div>
          <div className="admin-spinner-ring"></div>
        </div>
        {icon && <div className="admin-loading-icon" aria-hidden="true">{icon}</div>}
        <h2 className="admin-loading-title">{title}</h2>
        {subtitle && <p className="admin-loading-subtitle">{subtitle}</p>}
        <div className="admin-loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className="admin-loading-particles">
        <div className="admin-particle"></div>
        <div className="admin-particle"></div>
        <div className="admin-particle"></div>
        <div className="admin-particle"></div>
        <div className="admin-particle"></div>
      </div>
    </div>
  );
};

export default AdminLoading;
